import $ from 'jquery';
/**
 * Enables the "accordion" functionality.
 */
const enableAccordionFunctionality = () => {
    // Toggles the accordion header icon
    $('.accordion .card-header').on('click', function () {
        $('.icon', this).toggleClass('plus-icon').toggleClass('minus-icon');
    });
};
export default enableAccordionFunctionality;
